import {h, Component} from 'preact';
import invoke from 'lodash.invoke';
import prop from 'ramda/src/prop';
import cx from 'classnames';
import {withPickList} from '../index';

const labelClasses = 'text-inherit mb-2 border-solid box-border-round t-bg-color t-duration-short bg-white hover:bg-near-white';

class PickListItem extends Component {

    handleInput = e => {
        const {pickList} = this.props;
        let doHandleInput = false;

        switch ( e.type ) {
            case 'click':
                // Bug: onClick firing when radio button is selected with arrow keys
                // resource -> https://github.com/facebook/react/issues/7407
                if ( e.clientX !== 0 && e.clientY !== 0 ) {
                    doHandleInput = true;
                }
                break;

            case 'keypress':
                // [SPACE key]
                if ( e.which === 32 ) {
                    doHandleInput = true;
                }
                break;
        }

        if ( doHandleInput ) {
            invoke( pickList.actions, 'handleItemChange', e.target.value );
        }
    };
    handleChange = () => {};

    render ( props ) {
        const {itemIdProp, selectedItem, groupId} = props.pickList;
        const itemId = prop( itemIdProp, props );
        const isChecked = prop( itemIdProp, selectedItem ) === itemId;
        const Component = props.renderer || DefaultRenderer;

        // FIXME -> need to sanitize data models passed to th=is component when Dealing with
        // Apollo cache because it attaches a Symbol(id) property key that is breaking
        // the render loop in Preact
        const {Symbol, ...itemProps} = props;

        return (
            <label htmlFor={`${groupId}-${itemId}`} className={labelClasses}>
                <Component {...itemProps}>
                <span className="wrap-check mr-4">
                    <input id={`${groupId}-${itemId}`}
                           type="radio"
                           tabIndex="0"
                           name={groupId}
                           value={itemId}
                           checked={isChecked}
                           onKeyPress={this.handleInput}
                           onClick={this.handleInput}/>
                    <span className={cx( 'radio', {checked: isChecked} )}></span>
                </span>
                </Component>
            </label>
        );
    }
}

const DefaultRenderer = ( {className = '', children, ...data} ) => (
    <div className={className}>
        {children}
        {Object
            .entries( data )
            .map( ( [key, value] ) =>
                <span className="block">{key} - {String( value )}</span>
            )}
    </div>
);

export default withPickList( PickListItem );
